import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  PermissionListState,
  PERMISSION_LIST_STATE,
} from './permission-list.state';

export const selectPermission = createFeatureSelector<PermissionListState>(
  PERMISSION_LIST_STATE
);

export const selectPermissionList = createSelector(
  selectPermission,
  (state: PermissionListState) => {
    return state.dataSource;
  }
);

export const selectPermissionListFilter = createSelector(
  selectPermission,
  (state: PermissionListState) => state.filter
);
